import { useState } from "react";

/**
 * Which way the flow last moved, from the step position it renders. The
 * thank-you screen sits past the last step, so reaching it is forward.
 */
function useStepDirection(stepPosition: number): "back" | "forward" {
  const [positions, setPositions] = useState({
    current: stepPosition,
    previous: stepPosition,
  });
  if (positions.current !== stepPosition) {
    setPositions({ current: stepPosition, previous: positions.current });
  }

  return positions.previous > stepPosition ? "back" : "forward";
}

export { useStepDirection };
